
import React from 'react'
import { Form } from 'react-bootstrap'
import useTranslation from '../../../Hooks/UseTranslation'
import { useProgrammation } from '../../../Hooks/UseProgrammation'
import InputSelect from '../components/InputSelect'
import { updateTaskField } from '../../../Services/ProgrammationManagerService'
import { useDispatch } from 'react-redux'
import { updateTaskFieldAction } from '../../../Redux/Actions/ProgrammationManagerActions'

const TaskDisplayMode = () => {

  const { t } = useTranslation()

  const dispatch = useDispatch()

  const { itemOpened, setEditingItem, patchItemOpened } = useProgrammation()

  const options = [
    { label: 'Scheduled', value: 'scheduled' },
    { label: 'Actual', value: 'actual' },
  ]

  const handleChangeDisplayMode = async (displayMode: string) => {

    setEditingItem(true)

    const [ error ] = await updateTaskField(itemOpened._id, 'displayMode', displayMode)

    if (error) {
      return console.log(error)
    }

    patchItemOpened({
      displayMode,
    })

    await dispatch(updateTaskFieldAction(itemOpened._id, 'displayMode', displayMode))

    setEditingItem(false)
  }

  return (
    <Form.Group>
      <Form.Label>
        {t('PROGRAMMATION_MANAGER:DisplayModeLabel')}
      </Form.Label>
          <InputSelect
            value={itemOpened.displayMode}
            onChange={handleChangeDisplayMode}
            placeholder={t('PROGRAMMATION_MANAGER:SelectPlaceholder')}
            options={options}
            renderOption={(option: any) => (
              <option value={option.value}>
                {option.label}
              </option>
            )}
          />
    </Form.Group>
  )
}

export default TaskDisplayMode
